import React from 'react';
import { Arrow } from './style';
import useAnnotationMarkPositionStyles from 'components/text-editor/components/annotations/components/hooks/use-annotation-mark-position-styles';
import useCustomEditor from 'components/text-editor/hooks/use-custom-editor';
import useTextSnippetSelection from 'components/text-editor/components/controls/hooks/use-selected-text-snippet';
import { usePrevious } from 'hooks';
import { Node } from 'slate';
import { isDefined, notEqual } from 'utils/js';

export interface NameSnippetArrowProps {
  element: Node;
  isNote: boolean;
}

const defaultProps = {};

function NameSnippetMark(props: NameSnippetArrowProps) {
  const editor = useCustomEditor();

  const { setSelectedTextSnippet } = useTextSnippetSelection(editor);

  const positionStyles = useAnnotationMarkPositionStyles(props.element) as any;
  const previousStyles = usePrevious(positionStyles);
  const [lastUpdated, setLastUpdated] = React.useState(
    new Date().toISOString(),
  );

  React.useEffect(() => {
    if (notEqual(positionStyles, previousStyles)) {
      setLastUpdated(new Date().toISOString());
    }
  }, [previousStyles, positionStyles]);

  if (isDefined(positionStyles.left)) {
    if (positionStyles.left === 0) {
      positionStyles.left = -3;
    } else {
      positionStyles.left -= 1;
    }
  }

  function selectAnnotation() {
    //@ts-ignore
    const annotationId = props?.element.annotationId;

    if (annotationId) {
      const at = editor.getSlateRangeByAnnotationId(annotationId);

      editor.unMarkNodesAsSelected();

      editor.saveAnnotation(at, { isSelected: true, annotationId });

      const selectedNode = editor.getSelectedNode();

      selectedNode && setSelectedTextSnippet(selectedNode);
    }
  }

  return React.useMemo(
    () => (
      <Arrow
        style={positionStyles}
        contentEditable={false}
        isNote={props.isNote}
        onClick={selectAnnotation}
      />
    ),
    [lastUpdated],
  );
}

NameSnippetMark.defaultProps = defaultProps;

export default NameSnippetMark;
